import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authClient } from '../lib/authClient';
import { styles } from './SignIn';

// Always shows the same confirmation, whether or not the email has an account, so the page
// can't be used to find out who's registered. Better Auth's endpoint answers the same way.
export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { error: authError } = await authClient.requestPasswordReset({ email, redirectTo: '/reset-password' });
      if (authError?.status === 429) setError('Too many attempts, try again in a few minutes.');
      else if (authError) setError('Something went wrong. Please try again.');
      else setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Forgot password</h1>
        {sent ? (
          <p style={styles.text}>
            If that email has a GigRequest account, we've sent a link to reset the password.
            It expires in an hour. Check your spam folder if it hasn't arrived in a few minutes.
          </p>
        ) : (
          <>
            <p style={styles.text}>Enter your account's email and we'll send you a link to set a new password.</p>
            <form onSubmit={handleSubmit} style={styles.form}>
              <input
                type="email"
                autoComplete="email"
                placeholder="Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                style={styles.input}
              />
              {error && <p style={styles.error}>{error}</p>}
              <button type="submit" disabled={loading} style={styles.button}>
                {loading ? 'Sending…' : 'Send reset link'}
              </button>
            </form>
          </>
        )}
        <p style={styles.footer}>
          <Link to="/sign-in" style={styles.link}>Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
